import {
  FaStar,
  FaUtensils,
  FaShoppingBag,
  FaMotorcycle,
} from "react-icons/fa";

import "./ProviderStats.css";

export default function ProviderStats({
  stats = {},
}) {
  return (
    <section className="provider-stats">

      <div className="provider-stat-card">

        <FaStar className="stat-icon" />

        <div>
          <h3>{stats.averageRating || 0}</h3>
          <p>Average Rating</p>
        </div>

      </div>

      <div className="provider-stat-card">

        <FaShoppingBag className="stat-icon" />

        <div>
          <h3>{stats.totalOrders || 0}</h3>
          <p>Orders</p>
        </div>

      </div>

      <div className="provider-stat-card">

        <FaUtensils className="stat-icon" />

        <div>
          <h3>{stats.totalFoods || 0}</h3>
          <p>Foods</p>
        </div>

      </div>

      <div className="provider-stat-card">

        <FaMotorcycle className="stat-icon" />

        <div>
          <h3>{stats.deliveryRadius || 5} km</h3>
          <p>Delivery</p>
        </div>

      </div>

    </section>
  );
}